import { render, staticRenderFns } from "./environment.vue?vue&type=template&id=7196a4cb&scoped=true&"
import script from "./environment.vue?vue&type=script&lang=js&"
export * from "./environment.vue?vue&type=script&lang=js&"
import style0 from "./environment.vue?vue&type=style&index=0&id=7196a4cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196a4cb",
  null
  
)

export default component.exports